import { render, staticRenderFns } from "./cancel-shipment-confirmation.vue?vue&type=template&id=162d7033&"
import script from "./cancel-shipment-confirmation.vue?vue&type=script&lang=js&"
export * from "./cancel-shipment-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports